import { ReducerRegistry } from '../base/redux';

import {
    CLOSE_PARTICIPANTS_PANE_MODAL,
    OPEN_PARTICIPANTS_PANE_MODAL,
    PARTICIPANTS_PANE_CLOSE,
    PARTICIPANTS_PANE_OPEN
} from './actionTypes';
import { REDUCER_KEY } from './constants';

const DEFAULT_STATE = {
    isOpen: false,
    isParticipantsPaneModalOpen: false
};

/**
 * Listen for actions that mutate the participants pane state.
 */
ReducerRegistry.register(
    REDUCER_KEY, (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case PARTICIPANTS_PANE_CLOSE:
            return {
                ...state,
                isOpen: false
            };

        case PARTICIPANTS_PANE_OPEN:
            return {
                ...state,
                isOpen: true
            };
        case OPEN_PARTICIPANTS_PANE_MODAL:
            return {
                ...state,
                isParticipantsPaneModalOpen: true
            };
        case CLOSE_PARTICIPANTS_PANE_MODAL:
            return {
                ...state,
                isParticipantsPaneModalOpen: false
            };

        default:
            return state;
        }
    }
);
